import { render } from "./CodeInput.vue?vue&type=template&id=477c36b2&scoped=true"
import script from "./CodeInput.vue?vue&type=script&lang=js"
export * from "./CodeInput.vue?vue&type=script&lang=js"

import "./CodeInput.vue?vue&type=style&index=0&id=477c36b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477c36b2"]])

export default __exports__